module.exports = __webpack_public_path__ + "df_font02.jpg?675f490be1d30503e483ec33251970a7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/digital _factory/df_font02.jpg
// module id = 51
// module chunks = 0